import {useCompanySubscription} from '@product-web/paywall/lib/company-subscription'

export const useBillingAddonsByType = (type: string) => {
    const {data: companySubscriptionData} = useCompanySubscription()

    return companySubscriptionData?.addonRatePlans?.find(
        (addon: {type: string}) => addon.type === type,
    )?.charges?.[0]
}
